import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HasPermissionDirective } from "./has-permission.directive";
import { PermissionsService } from "./permissions.service";

@NgModule({
  declarations: [HasPermissionDirective],
  imports: [CommonModule],
  exports: [HasPermissionDirective],
  providers: [PermissionsService],
})
export class AuthorizationModule {}
